const registerStaffEN = {
	step: "Step {{step}} of 3",

	step1: {
		title: "Create An Account",
		subtitle: "You've been invited to join a team on Sin Fila. Pick a password to get started.",
		invitedTo: "Joining as",
		sectionAbout: "About you",
		sectionSecurity: "Security",
		firstName: "First name",
		lastName: "Last name",
		phone: "Phone number",
		password: "Password",
		confirmPassword: "Confirm Password",
		remember: "Remember me",
		register: "Register",
		registering: "Registering...",
		acceptTerms: "I agree to the",
		termsLink: "Terms & Conditions",
		email: "Email",
	},

	step2: {
		title: "Register Your Shop",
		shopName: "Shop name",
		address: "Address",
		city: "City",
		country: "Country",
		postalCode: "Postal Code",
		description: "Description",
		category: "Business Type",
		openingHours: "Opening Hours",
		closed: "Closed",
		socials: "Social Media Links",
		instagram: "Instagram URL",
		facebook: "Facebook URL",
		tiktok: "TikTok URL",
		website: "Website URL",
		next: "Next step",
		registering: "Registering...",
	},

	step3: {
		title: "Add Services",
		description: "Add at least one service to finish your setup.",
		photos: "Portfolio Photos",
		upload: "Upload Photos",
		finish: "Finish Setup",
		registering: "Registering...",
	},

	errors: {
		fillRequired: "Almost there! Please fill in the required fields to continue.",
		passwordMatch: "Those passwords don't match — give it another look.",
		uploadImages: "Add at least one photo to finish setting up.",
		invalidInvite: "This invite link isn't valid anymore. Please request a new one.",
		mustAcceptTerms: "Please accept the Terms & Conditions to continue.",
	},

	success: {
		adminCreated: "You're all set! Now let's set up your shop.",
		returning: "Welcome back! Let's keep setting up your shop.",
	},

	days: {
		Monday: "Monday",
		Tuesday: "Tuesday",
		Wednesday: "Wednesday",
		Thursday: "Thursday",
		Friday: "Friday",
		Saturday: "Saturday",
		Sunday: "Sunday",
	},
};

export default registerStaffEN;
